"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _withTranslation = require("../hoc/withTranslation");

var _styles = require("../styles");

/**
 * @props color, padding, value, margin, cursor, translate
 * @notes please use color name based on styledTheme (string) - i.e. color='main'
 * @translate to translate just use the translate prop passing the id of translation
 * @value option instead of children, recommended, just pass a string with the text
 */
var TitleH5 = (0, _withTranslation.withTranslation)(_styles.TitleH5Styled);
var _default = TitleH5;
exports.default = _default;